import EntityEditPage from './entity/EntityEditPage'
import EntityPage from './entity/EntityPage'
import ModulePage from './module/ModulePage'
import { FormDemo } from './page/FormDemo'
import FormDesiger from './page/FormDesiger'
import GridDemo from './page/GridDemo'
import GridDesiger from './page/GridDesiger'
import ParamPage from './param/ParamPage'
import { GirdLayoutDesiger } from './page/GirdLayoutDesiger'
import { Page } from './page/Page'
import Designer from './Designer'
import { PageLayoutDesiger } from './page/PageLayoutDesiger'
import PageHandler from './page/PageHandler'

// import ParamPage from './param/ParamPage'

const routes: IRoute[] = [
	{
		path: '/modeling',
		component: EntityPage,
		layout: 'modeling',
		name: '数据对象',
	},
	{
		path: '/modeling/entity',
		layout: 'modeling',
		component: EntityPage,
		name: '数据对象',
	},
	{
		path: '/modeling/entity/:id',
		layout: 'modeling',
		component: EntityEditPage,
		parentPath: '/modeling/entity',
		name: '修改数据对象',
	},
	{
		path: '/modeling/module',
		layout: 'modeling',
		component: ModulePage,
		name: '导航模块',
	},
	{
		path: '/modeling/page',
		layout: 'modeling',
		component: Page,
		name: '页面布局',
	},
	{
		path: '/modeling/parameters',
		layout: 'modeling',
		component: ParamPage,
		name: '业务参数',
	},
	{
		path: '/modeling/event',
		layout: 'modeling',
		component: Designer,
		name: '接口事件',
	},
	{
		path: '/demoPage',
		component: GridDemo,
		name: '页面设计',
	},
	{
		path: '/appGrid/:id',
		component: GridDesiger,
		name: '页面设计',
	},
	{
		path: '/std/:application/:type/:metadataId',
		component: PageHandler,
		name: '页面设计',
	},
	{
		path: '/appForm/:metadataId',
		component: FormDesiger,
		name: '页面设计',
	},
	{
		path: '/modeling/FormDemo',
		component: FormDemo,
		name: 'Form设计',
	},
	{
		path: '/modeling/desiger/gridDesiger',
		component: GirdLayoutDesiger,
		name: 'Grid建模',
		layout: 'public',
	},
	{
		path: '/modeling/desiger/pageDesiger',
		component: PageLayoutDesiger,
		name: '页面建模',
		layout: 'public',
	},
]
export default routes



// WEBPACK FOOTER //
// ./src/modules/modeling/index.ts